import { entityTypeNameFor } from "./entity-type-name-for";
export var isLink = function (entity) {
  return entityTypeNameFor(entity) === 'Link';
};